"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    collectAll: {
        height: 31,
        backgroundColor: '#479b3f',
        alignSelf: 'flex-end',
        display: 'flex',
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        right: '0%',
        bottom: 'auto',
        minWidth: '130px'
    },
    collectAllContent: {
        marginLeft: '5px',
        color: '#FFFFFF'
    },
    remainingAll: {
        height: 31,
        backgroundColor: '#f8d76e',
        alignSelf: 'flex-end',
        display: 'flex',
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        right: '0%',
        bottom: 'auto'
    },
    remainingAllContent: {
        padding: '0px 10px 0px 10px',
        color: '#000000'
    },
    checkIcon: {
        backgroundColor: 'white',
        borderRadius: '50%',
        display: 'flex',
        width: '15%'
    }
});
exports.default = styles;
//# sourceMappingURL=CollectAllStyles.js.map